import { Theme } from '@emotion/react'
import styled, { CSSObject } from '@emotion/styled'

interface L1TabularListTextProps {
	bold?: boolean
	color?: 'normal'|'affirmative'|'negative'
}

export const L1TabularListText = styled.div<L1TabularListTextProps>(({theme, bold, color}) => {
	let style: CSSObject = {}
	if(bold) {
		style = {
			...style,
			...theme.fonts.bodyBold,
		}
	}
	switch(color) {
		case 'affirmative':
			style.color = theme.colors.goGreen
			break
		case 'negative':
			style.color = theme.colors.inputLabel
			break
	}
	return style
})

interface L1TabularListTextCellProps extends L1TabularListTextProps {
	centered?: boolean
}

export const L1TabularListTextCell = styled(L1TabularListText)<L1TabularListTextCellProps>(({centered}) => {
	let style: CSSObject = {
		display: 'flex',
		flexDirection: 'column',
	}
	if(centered) {
		style.alignItems = 'center'
	}
	return style
})
